import moment from 'moment';
import {
  // 时间筛选器
  RANGE_TIME as FILTER_RANGE_TIME,
  // 组合下拉筛选器
  COMPOSED_SELECT as FILTER_COMPOSED_SELECT,
  // 级联国家筛选器
  REGION as FILTER_REGION,
  // 级联国家筛选器 继承类型
  REGION_EXTEND_TYPE as FILTER_REGION_EXTEND_TYPE,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';
import {
  getPCConsolePlatformsOptions,
  getPCConsoleTopsOptionsMapping,
} from '@/pages/intelligence/_config/storeRank/utils';
import {
  PC_PLATFORMS,
  PC_STORE_RANK_TOPS_MAPPING,
  PC_TOP_TOP_SELLERS,
} from '@/pages/intelligence/_config/storeRank/config';

const PLATFORMS_OPTIONS = getPCConsolePlatformsOptions('pc');
const PLATFORMS_TOPS_OPTIONS_MAPPING = getPCConsoleTopsOptionsMapping('pc');
const INITIAL_PLATFORM = PC_PLATFORMS[0];
const INITIAL_SHOP = PC_STORE_RANK_TOPS_MAPPING?.[INITIAL_PLATFORM]?.[0] ?? PC_TOP_TOP_SELLERS;

// 筛选器默认配置
export const FILTER_DEFAULT_INPUT_LIST_MAP = {
  RANGE_TIME: {
    key: FILTER_RANGE_TIME,
    showSelectType: true,
    typeList: ['date', 'week'],
    type: FILTER_RANGE_TIME,
    visible: 1,
    calendarType: 'date',
    startOfWeek: 2,
  },
  COMPOSED_SELECT: {
    key: FILTER_COMPOSED_SELECT,
    type: FILTER_COMPOSED_SELECT,
    visible: 1,
    isTranslate: true,
    parentOptions: PLATFORMS_OPTIONS,
    childOptionsMap: PLATFORMS_TOPS_OPTIONS_MAPPING,
  },
  REGION: {
    key: FILTER_REGION,
    type: FILTER_REGION,
    visible: 2,
    extendFilterType: FILTER_REGION_EXTEND_TYPE.common,
    disableNoChina: true,
    // "popularList": [
    //   "br",
    //   "mx",
    //   "ru",
    //   "tr",
    //   "us"
    // ],
    options: [],
    entityType: 'pc'
  },
};

// 筛选器默认值
export const FILTER_DEFAULT_VALUE = {
  [FILTER_RANGE_TIME]: {
    type: 'date',
    value: [moment().subtract(30, 'd'), moment().subtract(1, 'd')],
  },
  [FILTER_COMPOSED_SELECT]: {
    value: {
      parent: INITIAL_PLATFORM,
      child: INITIAL_SHOP,
    },
  },
  [FILTER_REGION]: {
    type: 'market',
    regions: [],
    markets: ['global'],
  },
};

// 筛选器默认配置
export const FILTER_DEFAULT_INPUT_LIST = [
  FILTER_DEFAULT_INPUT_LIST_MAP.RANGE_TIME,
  FILTER_DEFAULT_INPUT_LIST_MAP.COMPOSED_SELECT,
  FILTER_DEFAULT_INPUT_LIST_MAP.REGION,
];
